import * as React from 'react';
import { View, Text } from 'react-native';
import { Icon, Button } from 'react-native-elements';
import { useTranslation } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import useMediumScreen from 'hooks/useMediumScreen';
import useOrientationPortrait from 'hooks/useOrientationPortrait';
import useChangeAuthData from 'hooks/useChangeAuthData';
import AppContext from 'contexts/AppContext';
import OrderContext from 'contexts/OrderContext';
import { getVenues, getVenuesByFranchiseEditor } from 'services/venuesService';
import Venue from 'types/models/Venue';
import VenueSelectionScreenProps from 'types/screens/VenueSelectionScreenProps';
import UserRoleType from 'types/enums/UserRoleType';
import useChangeVenue from 'hooks/useChangeVenue';
import { styles } from 'styles/screens/venueSelectionScreen';
import LanguageSelector from 'components/LanguageSelector';
import CountryBillingType from 'types/enums/CountryBillingType';
import Storage from 'constants/Storage';
import { SupportedLanguages } from 'types/enums/LanguageType';

export default ({ navigation }: VenueSelectionScreenProps): JSX.Element => {
  const { i18n, t } = useTranslation();
  const { deleteAuthData } = useChangeAuthData();
  const { setModalData, authData } = React.useContext(AppContext);
  const { currentVenue } = React.useContext(OrderContext);
  const { storeCurrentVenue } = useChangeVenue();
  const mediumScreen = useMediumScreen();

  const orientationPort = useOrientationPortrait();
  const [venues, setVenues] = React.useState<Venue[] | null>(null);

  const fetchVenues = async () => {
    try {
      let venues: Venue[] | null = null;
      if (authData?.user.role === UserRoleType.FranchiseEditor) {
        venues = await getVenuesByFranchiseEditor();
      } else {
        venues = await getVenues();
      }
      if (venues) {
        setVenues(venues);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateLanguageByVenue = async (venue: Venue) => {
    const language: SupportedLanguages = venue.countryBillingConfigId === CountryBillingType.Brasil ? 'pt' : 'es';

    await AsyncStorage.setItem(Storage.language, language);
    i18n.changeLanguage(language);
  };

  React.useEffect(() => {
    fetchVenues();
  }, []);

  return (
    <View style={mediumScreen || orientationPort ? styles.container : styles.containerLandscape}>
      <View style={{ marginVertical: 10, flexDirection: 'row', justifyContent: 'space-between' }}>
        <View style={{ flexDirection: 'column', justifyContent: 'center', alignSelf: 'center', marginLeft: 60 }}>
          <Text style={{ fontWeight: '500', fontSize: 22, lineHeight: 20, letterSpacing: 0.25, textAlign: 'left' }}>
            Venues
          </Text>
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {mediumScreen && <LanguageSelector />}
        </View>
        <Icon
          name="person-circle-sharp"
          type="ionicon"
          color="#001C47"
          size={mediumScreen || orientationPort ? 60 : 35}
          containerStyle={mediumScreen ? styles.iconLarge : styles.iconSmall}
          onPress={() =>
            setModalData({
              description: t('logout'),
              generalColor: currentVenue?.appColor ?? '#001C47',
              action: async () => {
                await deleteAuthData();
              },
            })
          }
        />
      </View>
      <View
        style={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
        }}
      >
        {!mediumScreen && <LanguageSelector />}
      </View>

      <View style={styles.sectionContainer}>
        {venues?.map((venue, index) => {
          return (
            <Button
              title={venue.name}
              key={index}
              containerStyle={mediumScreen || orientationPort ? styles.btnContainerLarge : styles.btnContainerSmall}
              buttonStyle={styles.btnStyle}
              titleStyle={styles.btnTitle}
              onPress={async () => {
                await storeCurrentVenue(venue);
                updateLanguageByVenue(venue);
                if (
                  authData?.user.role === UserRoleType.VenueEditor ||
                  authData?.user.role === UserRoleType.FranchiseEditor
                ) {
                  navigation.navigate('CommercesScreen');
                } else {
                  navigation.push('OrdersScreen');
                }
              }}
            />
          );
        })}
      </View>
    </View>
  );
};
